import { type Enum } from '@webapp/infrastructure/types/Enum'

// Reconcile session lifecycle. Drives the Statement Details action:
// no session → "Reconcile", DRAFT → "Continue Reconciliation",
// SUBMITTED → "BILL #{group}" link.
export const ReconcileSessionStatuses = {
  DRAFT: 0, // Session open, reconciliation in progress
  SUBMITTED: 1, // Reconciled and submitted as a bill
  APPROVED: 2, // Bill approved
} as const

export type ReconcileSessionStatus = Enum<typeof ReconcileSessionStatuses>
